module.exports = __webpack_public_path__ + "media/images/premium/premium-card-po-lt-ff016d537a8aaa7ce925c096d3a577a8.svg";